import { useState } from "react";
import { CheckCircle2, LogOut, RefreshCw, ShieldCheck } from "lucide-react";
import { useAuth } from "@core/auth/AuthProvider";
import { TotpMfaCard } from "@core/auth/TotpMfaCard";
import { TitleToolbar } from "@core/components/TitleToolbar";
import { invokeVendorCallable } from "@core/data/callable";

export function SecuritySettingsPage() {
  const { user, isAppCheckConfigured, isDemoMode, signOut } = useAuth();
  const [revoking, setRevoking] = useState(false);
  const [message, setMessage] = useState("");

  const revokeSessions = async () => {
    setRevoking(true);
    setMessage("");
    try {
      if (!isDemoMode) {
        await invokeVendorCallable("authRevokeSessions", {});
        await signOut();
        return;
      }
      setMessage("The demo session has no server refresh tokens.");
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "Sessions could not be revoked.");
    } finally {
      setRevoking(false);
    }
  };
  return (
    <div className="settings-page-stack">
      <TitleToolbar
        density="compact"
        title="Authentication and session"
        icon={ShieldCheck}
      />
      <section className="settings-card security-status-list">
        <div><ShieldCheck /><span><strong>Authentication</strong><small>{isDemoMode ? "Development demo user" : "VenPro identity"}</small></span><CheckCircle2 className="status-good" /></div>
        <div><ShieldCheck /><span><strong>App Check</strong><small>{isAppCheckConfigured ? "App Check active" : "App Check pending"}</small></span><CheckCircle2 className={isAppCheckConfigured ? "status-good" : "status-warning"} /></div>
        <div><ShieldCheck /><span><strong>Current account</strong><small>{user.email || user.uid}</small></span><CheckCircle2 className="status-good" /></div>
      </section>
      <TotpMfaCard />
      <section className="settings-card">
        <div className="settings-card-header"><div><h2>Current session</h2><p>Signing out ends this VenPro browser session.</p></div></div>
        <div className="settings-form-actions">
          <button className="button button-secondary" type="button" disabled={revoking} onClick={revokeSessions}><RefreshCw /> {revoking ? "Revoking…" : "Revoke all sessions"}</button>
          <button className="button button-secondary" type="button" onClick={signOut}><LogOut /> Sign out</button>
        </div>
        {message && <div className="notice" role="status">{message}</div>}
      </section>
    </div>
  );
}
